import React from "react";
import { IoIosStar } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

const Card = ({ name, img, rating, btnText, id, link }) => {

  let handleOverview = () => {
    window.open(link);
  };

  return (
    <div className="shadow-xl">
      <div className="bg-white text-center rounded-t-md relative overflow-hidden">
        <img src={img} alt="img" />
        <div className="text-textColor text-xs py-2 w-40 font-normal absolute top-5 -right-12 bg-white rotate-45">
          Recorded
        </div>
      </div>
      <div className="px-4 py-5 ">
        <div className="flex justify-between items-center gap-3 mb-5 min-h-14 max-sm:flex-col max-sm:gap-3 max-sm:items-start">
          <h2 className="font-medium text-textColor">{name}</h2>
          <p className="flex gap-2 items-center max-sm:text-lg max-sm:font-medium text-textColor">
            {rating} <IoIosStar />
          </p>
        </div>
        {/* <p className="text-[#4A4A4A] text-sm mb-3"> {para} </p> */}
        <button
          className={clsx(
            "bg-primary rounded-md text-white font-normal w-full text-base  max-sm:text-xs py-[0.7rem] px-8 w-fit"
          )}
          onClick={handleOverview}>
          {btnText}
        </button>
      </div>
    </div>
  );
};

export default Card;
